import {
  SET_PAGINATION,
  SET_PAGE_INDEX,
  RESET_PAGE_AND_PAGINATION,
  SET_TYPE_OF_UPLOAD_DATASET,
  SET_ERROR_TYPE_OF_UPLOAD_DATASET,
  RESET_TYPE_OF_UPLOAD_DATASET
} from './types';

const initialState = {
  pagination: 100,
  pageIndex: 0,
  isErrorType: false
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_PAGINATION:
      return { ...state, pagination: action.pagination };
    case SET_PAGE_INDEX:
      return { ...state, pageIndex: action.pageIndex };
    case SET_TYPE_OF_UPLOAD_DATASET:
      return { ...state, typeOfUploadDataset: action.typeOfUploadDataset };
    case SET_ERROR_TYPE_OF_UPLOAD_DATASET:
      return { ...state, isErrorType: action.isErrorType };
    case RESET_PAGE_AND_PAGINATION:
    case RESET_TYPE_OF_UPLOAD_DATASET:
      return { ...initialState };
    default:
      return state;
  }
};
